import React from 'react';

import TimeBoundSelect from 'components/RabbitTimePeriodDropdown/TimeBoundSelect';
import { useTimeBoundTimePeriods } from 'screens/home/summary/components/Cards/Goals/hooks';

import { getTimePeriodIdString } from 'constants/helper';

import { GenericControl, ReadOnlyGenericControl } from 'uiToolkitV1/SelectV2/GenericControl';

export const TimelineSelect = ({
  selectedTimeline,
  onSelect = () => {},
  isReadOnly = false,
  showCalendarIcon = false,
}) => {
  const { data: timelineData, isLoading: timelineAPILoading } = useTimeBoundTimePeriods();

  if (timelineAPILoading) return null;

  const { previous, current, next, other = [] } = timelineData;
  const previousCurrentNext = [previous, current, next].filter((item) => Boolean(item));
  const allTimePeriods = [previous, current, next, ...other].filter((item) => Boolean(item));

  const menuItems = previousCurrentNext.map((timeBound) => {
    const { timelineTag, startTS, endTS } = timeBound;
    return {
      value: getTimePeriodIdString({ timelineTag, startTS, endTS }),
      label: timelineTag,
      tag: timeBound === current ? 'Current' : '',
    };
  });

  const otherMenuItems = other.map(({ startTS, endTS, timelineTag }) => ({
    value: getTimePeriodIdString({ timelineTag, startTS, endTS }),
    label: timelineTag,
  }));
  const currentSelectedValue = getTimePeriodIdString(selectedTimeline);

  const handlePeriodChange = (selectedTimePeriodIdString) => {
    const selectedTimePeriodObject = allTimePeriods.find(
      ({ startTS, endTS, timelineTag }) =>
        selectedTimePeriodIdString === getTimePeriodIdString({ timelineTag, startTS, endTS })
    );
    onSelect(selectedTimePeriodObject);
  };

  return (
    <TimeBoundSelect
      selectedValue={currentSelectedValue}
      onChange={handlePeriodChange}
      menuItems={menuItems}
      otherMenuItems={otherMenuItems}
      width="100%"
      renderAsRefableComp={isReadOnly ? ReadOnlyGenericControl : GenericControl}
      showCalendarIcon={showCalendarIcon}
    />
  );
};
